module.exports = __webpack_public_path__ + "media/images/drop-ac1a1b7f155a0746ccf8354eb0718aa2.svg";